import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=a0184e94&scoped=true&"
import script from "./accountSetting.vue?vue&type=script&lang=js&"
export * from "./accountSetting.vue?vue&type=script&lang=js&"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=a0184e94&lang=scss&scoped=true&"
import style1 from "./accountSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0184e94",
  null
  
)

component.options.__file = "accountSetting.vue"
export default component.exports